exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".meta__thema a[data-v-3ed4415c]:not(:last-child):after{content:\"|\"}", ""]);

// exports
